<template>
  <div :class="containerClasses">
    <!-- /* c8 ignore start */ -->
    <cdr-accordion
      :id="type"
      :level="3"
      :opened="isOpen"
      data-analytics-config="exclude-all"
      @accordion-toggle="$emit('toggle')"
    >
      <!-- /* c8 ignore end */ -->
      <template #label>
        <div class="app-acc__label">
          <icon-check-fill class="app-acc__icon" />
          <cdr-text class="app-acc__heading">
            {{ heading }}
          </cdr-text>
        </div>
        <span
          v-if="sublabel"
          v-dompurify-html="sublabel"
          class="app-acc__sublabel"
        />
      </template>
      <slot />
    </cdr-accordion>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { CdrAccordion, CdrText, IconCheckFill } from '@rei/cedar';

const props = defineProps({
  heading: {
    type: String,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  sublabel: {
    type: String,
    required: false,
    default: '',
  },
  type: {
    type: String,
    required: true,
  },
});

const $emit = defineEmits(['toggle']);

const containerClasses = computed(() => ({
  'app-acc': true,
  'app-acc--complete': props.isComplete,
}));
</script>

<style lang="scss">

.app-acc {
  box-shadow: $cdr-prominence-raised;
  border: 1px solid $cdr-color-border-primary;
  border-radius: $cdr-radius-softer;

  [class*="cdr-accordion__icon"] {
    margin-left: 0;
  }
}

.app-acc__icon.app-acc__icon {
  fill: $cdr-color-border-primary;
}

.app-acc__heading {
  white-space: nowrap;
}

.app-acc__label {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  grid-template-columns: 30px 1fr;
  @include cdr-md-mq-up {
    grid-column-gap: $cdr-space-quarter-x;
  }
}

.app-acc__sublabel.app-acc__sublabel {
  display: inline-block;
  margin-top: $cdr-space-half-x;
  @include cdr-text-utility-sans-200;
  span {
    font-weight: 500;
  }
}

.app-acc__heading.app-acc__heading {
  @include cdr-text-heading-sans-300;
}

.app-acc--complete {
  .app-acc__icon.app-acc__icon {
    fill: $cdr-color-text-success;
  }
  .app-acc__heading {
    color: $cdr-color-text-success;
  }
}

</style>
